{
  "name": "@classic-homes/theme-mcp",
  "version": "0.1.38",
  "description": "MCP server for Classic Theme design system - enables AI assistants to understand and correctly use components, tokens, and patterns",
  "type": "module",
  "main": "dist/index.js",
  "types": "dist/index.d.ts",
  "bin": {
    "classic-theme-mcp": "./dist/cli.js"
  },
  "exports": {
    ".": {
      "types": "./dist/index.d.ts",
      "default": "./dist/index.js"
    }
  },
  "sideEffects": false,
  "files": [
    "dist",
    "README.md"
  ],
  "keywords": [
    "mcp",
    "model-context-protocol",
    "ai",
    "claude",
    "design-system",
    "classic-theme",
    "components",
    "svelte",
    "react",
    "tailwindcss"
  ],
  "repository": {
    "type": "git",
    "url": "https://github.com/Classic-Homes/classic-theme.git",
    "directory": "packages/mcp"
  },
  "bugs": {
    "url": "https://github.com/Classic-Homes/classic-theme/issues"
  },
  "homepage": "https://theme.classichomes.com/svelte/docs/getting-started/ai-integration",
  "license": "MIT",
  "author": "Classic Homes",
  "scripts": {
    "build": "npm run generate && tsup",
    "build:fast": "tsup",
    "generate": "tsx scripts/generate-catalog.ts",
    "dev": "tsup --watch",
    "start": "node dist/cli.js",
    "typecheck": "tsc --noEmit",
    "validate": "tsx scripts/validate-catalog-integrity.ts",
    "clean": "node ../../scripts/rm.mjs dist",
    "prepublishOnly": "npm run build"
  },
  "dependencies": {
    "@modelcontextprotocol/sdk": "^1.11.0",
    "zod": "^3.25.0"
  },
  "devDependencies": {
    "@classic-homes/auth": "*",
    "@classic-homes/charts-core": "*",
    "@classic-homes/charts-svelte": "*",
    "@classic-homes/data-panel-core": "*",
    "@classic-homes/maps-core": "*",
    "@classic-homes/maps-react": "*",
    "@classic-homes/maps-svelte": "*",
    "@classic-homes/native": "*",
    "@classic-homes/notifications": "*",
    "@classic-homes/theme-docs": "*",
    "@classic-homes/theme-styles": "*",
    "@classic-homes/theme-svelte": "*",
    "@classic-homes/theme-tailwind-preset": "*",
    "@classic-homes/theme-tokens": "*",
    "@types/node": "^22.0.0",
    "glob": "^11.0.0",
    "tsup": "^8.0.0",
    "tsx": "^4.0.0",
    "typescript": "^5.3.0"
  },
  "engines": {
    "node": ">=18.0.0"
  }
}
